import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TenantLogoComponent } from '../tenant-logo/tenant-logo.component';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss',
  imports: [TenantLogoComponent, TranslateModule],
})
export class AuthCallbackComponent {}
